import React, { useRef, useEffect, useState } from "react";

var styles = {
  attachmentVideo: {
    maxHeight: "inherit",
    maxWidth: "inherit",
    minHeight: "inherit",
    minWidth: "inherit",
    objectFit: "cover",
  },
};

export default ({ attachmentSrc, videoDisplay = false, type = "video/mp4" }) => {
  const classes = styles;
  const videoEl = useRef(null);
  const [playing, setPlaying] = useState(true);
  const [videoType, setVideoType] = useState(type);

  useEffect(() => {
    if (attachmentSrc) {
      if (typeof attachmentSrc === 'string') {
        if (attachmentSrc.includes('.webm')) {
          setVideoType('video/webm');
        } else if (attachmentSrc.includes('.mp4')) {
          setVideoType('video/mp4');
        } else if (attachmentSrc.includes('.mov')) {
          setVideoType('video/quicktime');
        } else if (typeof type === 'string' && type.includes('/')) {
          setVideoType(type);
        }
      }
    }

    setPlaying(true);

    const videoRef = videoEl.current;

    return () => {
      setPlaying(false);
      if (videoRef) {
        videoRef.pause();
      }
    };
  }, [attachmentSrc, type]);

  const onVideoClick = () => {
    setPlaying(!playing);

    if (playing) {
      return videoEl?.current?.pause();
    } else {
      return videoEl?.current?.play().catch(err => {
        console.error("Error playing video:", err);
      });
    }
  };

  return (
    <video
      controls
      style={!videoDisplay ? classes.attachmentVideo : videoDisplay}
      autoPlay
      ref={videoEl}
      preload="metadata"
      src={attachmentSrc}
      onClick={onVideoClick}
      type={videoType}
    />
  );
};
